import { FC, MouseEvent, useContext } from "react";
import { Link } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { AuthContext } from "src/context/authContext";

import { LogoBrandLight } from "src/assets";
import { generateTour } from "src/constants/tour";

import { APIEndpoints } from "src/types/apiTypes";
import { LogoutAPISuccessResponseType } from "./types";



const UserDropdown: FC = (): JSX.Element => {
  const { isManufacturer, userData, destroySession } = useContext(AuthContext)
  const completeTour = generateTour()


  const { mutate } = useFetch<LogoutAPISuccessResponseType>(APIEndpoints.USER_LOGOUT);

  // useEffect(() => {
  //   if (data || error) {
  //     hideLoader();
  //     destroySession();
  //     const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
  //     window.location.replace(redirect_url || "")
  //     // else navigate('/users/sign_in')
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data, error]);

  const logoutUser = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // if ((error && error.length > 0) || data) removeErrorAndData();

    // setLoader();
    destroySession();
    mutate();

    const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
    if (redirect_url) window.location.replace(redirect_url || "")
  };

  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('authHeader');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  if (isManufacturer) {
    return (
      <>
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
            aria-expanded="false" role="button"
          >
            {userData?.name}
          </a>
          <ul className="dropdown-menu dropdown-menu-end">
            {/* <li>
              <Link className="dropdown-item text-black" to='/users/updateuser'>
                Account Settings
              </Link>
            </li> */}
            {/* <li>
              <hr className="dropdown-divider"/>
            </li> */}
            <li>
              <a className="dropdown-item text-black" href="."
                 onClick={(e) => {
                   closeMobileMenu();
                   logoutUser(e);
                 }}
              >Logout</a>
            </li>
          </ul>
        </li>
        <li className="nav-item">
          <img src={LogoBrandLight} alt="Nav menu logo"/>
        </li>
      </>
    )
  } else {
    return (
      <>
        {window.location.pathname === "/cases" && (
            <li className="nav-item dropdown">
              <button onClick={completeTour.start} className="btn btn-success rounded-0"
                      type="button" style={{minHeight: "50px"}}>
                Take a Tour
              </button>
            </li>
        )}
        <li className="nav-item dropdown">
          <a
              className="nav-link dropdown-toggle" href="."
              data-bs-toggle="dropdown"
              aria-expanded="false"
              role="button"
          >
            {userData?.name}
          </a>
          <ul className="dropdown-menu dropdown-menu-end">
            {/* <li><Link className="dropdown-item text-black" to="/users/updateuser">
              Account Settings</Link>
            </li>
            <li><Link className="dropdown-item text-black" to="/users/new">Add User</Link>
            </li>
            <li><Link className="dropdown-item text-black" to="/doctors/new">
              Add Doctor
            </Link></li> */}
            <li><Link className="dropdown-item text-black" to="/pages/baa" onClick={closeMobileMenu}>BAA</Link></li>
            <li>
              <hr className="dropdown-divider"/>
            </li>
            <li><a className="dropdown-item text-black" href="." onClick={(e) => {
              closeMobileMenu();
              logoutUser(e);
            }}>
              Logout
            </a></li>
          </ul>
        </li>
        <li className="nav-item">
          <img src={LogoBrandLight} alt="Nav menu logo"/>
        </li>
      </>
    )
  }
}

export default UserDropdown
